
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M12.385 16.125h-6.26c-2.3 0-4.065-.83-3.563-4.174l.583-4.53c.309-1.669 1.373-2.307 2.307-2.307h7.633c.948 0 1.95.686 2.307 2.306l.584 4.531c.425 2.966-1.29 4.174-3.59 4.174z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.488 4.949a3.24 3.24 0 00-3.24-3.24v0a3.24 3.24 0 00-3.254 3.24h0M11.472 8.326h-.034M7.1 8.326h-.035","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    